import React from 'react';
import Header from '../Navigation/Header';
import Footer from '../Navigation/Footer';
import styled from 'styled-components';
import { mobileMediaQuery } from '../Theming';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin: 0 auto;

  ${mobileMediaQuery} {
    margin: 0 0;
  }
`;

const DefaultLayout: React.FC = ({ children }) => {
  return (
    <>
      <Header />
      <Container>{children}</Container>
      <Footer />
    </>
  );
};

export default DefaultLayout;
